import { normalizeName, matchNamePrepositions, calculateNameProfile, calculateDateProfile, createSimpleReportProjection, createSimpleCyclesProjection } from './generated/core/index.mjs';
export { normalizeName, matchNamePrepositions };
export function civilToday() {
  const date = new Date();
  return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
}
export function dateInputValue(date = civilToday()) {
  return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
}
export function nameChoices(name, restored = []) {
  const matches = matchNamePrepositions(name);
  const excluded = new Set(matches.filter(match => !restored.includes(match.key)).flatMap(match =>
    Array.from({ length: match.endPartIndex - match.startPartIndex + 1 }, (_, i) => i + match.startPartIndex)));
  const words = normalizeName(name).split(' ').filter((_, i) => !excluded.has(i));
  const ys = words.flatMap(word => [...word].flatMap((letter, index) => letter === 'Y' ? [{ word, index }] : []));
  return { matches, ys };
}
export function calculateWebMap(input, asOf = civilToday()) {
  if (typeof input.name !== 'string' || input.name.length > 160 || !/^[\p{L}\p{M}\s'’ʻʼʹ＇\p{Dash_Punctuation}]+$/u.test(input.name) || !normalizeName(input.name)) throw new Error('name');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(input.birthDate)) throw new Error('date');
  const [year, month, day] = input.birthDate.split('-').map(Number);
  const birth = { year, month, day };
  let dateProfile;
  try { dateProfile = calculateDateProfile(birth, asOf); } catch { throw new Error('date'); }
  const { ys } = nameChoices(input.name, input.restored);
  if (ys.length !== input.ys.length || input.ys.some(kind => !['vowel', 'consonant'].includes(kind))) throw new Error('y');
  const nameProfile = calculateNameProfile(input.name, { restoredPrepositionMatchKeys: input.restored, yClassifications: input.ys });
  const report = createSimpleReportProjection(nameProfile, dateProfile);
  const cycles = createSimpleCyclesProjection(dateProfile);
  return { name: input.name.trim(), birth, report, cycles,
    currentPinnacle: cycles.periods.find(period => period.isCurrent).pinnacle };
}
